<template>
  <div id="devicePosition" style="width: 100vw; height: 91vh">
    <el-container v-if="onOff" v-loading="isLoging" style="height: 91vh">
      <el-aside style="background-color: #ffffff" width="350px">
        <BoothAreaList :areaList="list" @onAreaClick="handleAreaClick" @onPointClick="handlePointClick"></BoothAreaList>
      </el-aside>
      <el-main style="height: 91vh; padding: 0">
        <div class="infobox-content" v-if="showPoint">
          <el-descriptions :title="baInfo.baName || '未选择摊位区域'">
            <el-descriptions-item label="总摊位数(总点位)">{{ baInfo.total }}</el-descriptions-item>
            <el-descriptions-item label="经营中摊位数">{{ baInfo.inuse }}</el-descriptions-item>
            <el-descriptions-item label="省份">{{ baInfo.province }}</el-descriptions-item>
            <el-descriptions-item label="城市">{{ baInfo.city }}</el-descriptions-item>
            <el-descriptions-item label="地区">{{ baInfo.area }}</el-descriptions-item>
            <el-descriptions-item label="详细地址">{{ baInfo.address }}</el-descriptions-item>
          </el-descriptions>
          <el-button type="primary" @click="backToArea">返回摊区详情</el-button>
        </div>
        <div class="map" :class="showPoint?'style1':'style2'">
          <AMapComponent
            ref="amap"
            :areaList="list"
            :onSelectedArea="handleSelectedArea"
            :onSelectedAreaPoint="handlePointClick"
          ></AMapComponent>
        </div>
      </el-main>
    </el-container>

    <el-dialog :title="`${baInfo.baName}-${boothInfo.baPoint}`" :visible.sync="dialogVisible" width="700px">
      <el-descriptions>
        <el-descriptions-item label="摊位名称">{{ boothInfo.boothName }}</el-descriptions-item>
        <el-descriptions-item label="摊位简称">{{ boothInfo.boothShortName }}</el-descriptions-item>
        <el-descriptions-item label="摊位号">{{ boothInfo.boothNo }}</el-descriptions-item>
      </el-descriptions>

      <el-descriptions>
        <el-descriptions-item label="摊位分类">{{ boothInfo.category }}</el-descriptions-item>
        <el-descriptions-item label="商户号">
          {{ boothInfo.mchNo }}
        </el-descriptions-item>

        <el-descriptions-item label="场地方号">
          {{ boothInfo.lalNo }}
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions>
        <el-descriptions-item label="联系人姓名">{{ boothInfo.contactName }}</el-descriptions-item>
        <el-descriptions-item label="联系人手机号">{{ boothInfo.contactTel }}</el-descriptions-item>
        <el-descriptions-item label="联系人邮箱">{{ boothInfo.contactEmail }}</el-descriptions-item>
      </el-descriptions>
      <el-button type="primary" @click="sendDevicePush(boothInfo)" v-if="boothInfo.device != null">打开监控</el-button>
      <el-descriptions>
        <el-descriptions-item label="摊位门头照">
          <template v-for="url in boothInfo.photo">
            <el-image :preview-src-list="boothInfo.photo" :src="url" style="width: 100px; height: 100px"> </el-image>
          </template>
        </el-descriptions-item>
        </el-descriptions>

        <el-descriptions>
        <el-descriptions-item label="公示卡">
          <template v-for="url in boothInfo.publicCard">
            <el-image :preview-src-list="boothInfo.publicCard" :src="url" style="width: 100px; height: 100px">
            </el-image>
          </template>
        </el-descriptions-item>
        </el-descriptions>

        <el-descriptions>
        <el-descriptions-item label="登记卡">
          <template v-for="url in boothInfo.registerCard">
            <el-image :preview-src-list="boothInfo.registerCard" :src="url" style="width: 100px; height: 100px">
            </el-image>
          </template>
        </el-descriptions-item>
        </el-descriptions>

        <el-descriptions>
        <el-descriptions-item label="身份证">
          <template v-for="url in boothInfo.identityCard">
            <el-image :preview-src-list="boothInfo.identityCard" :src="url" style="width: 100px; height: 100px">
            </el-image>
          </template>
        </el-descriptions-item>
        </el-descriptions>

        <!-- <el-descriptions>
        <el-descriptions-item label="人脸识别">
          <template v-for="url in boothInfo.faceRecognition">
            <el-image :preview-src-list="boothInfo.faceRecognition" :src="url" style="width: 100px; height: 100px">
            </el-image>
          </template>
        </el-descriptions-item>
        </el-descriptions> -->

        <el-descriptions>
        <el-descriptions-item label="健康证">
          <template v-for="url in boothInfo.healthCertificate">
            <el-image :preview-src-list="boothInfo.healthCertificate" :src="url" style="width: 100px; height: 100px">
            </el-image>
          </template>
        </el-descriptions-item>
        </el-descriptions>

        <el-descriptions>
        <el-descriptions-item label="居住证">
          <template v-for="url in boothInfo.residenceCertificate">
            <el-image :preview-src-list="boothInfo.residenceCertificate" :src="url" style="width: 100px; height: 100px">
            </el-image>
          </template>
        </el-descriptions-item>
        </el-descriptions>

        <el-descriptions>
        <el-descriptions-item label="经营承诺书">
          <template v-for="url in boothInfo.businessCommitment">
            <el-image :preview-src-list="boothInfo.businessCommitment" :src="url" style="width: 100px; height: 100px">
            </el-image>
          </template>
        </el-descriptions-item>
        </el-descriptions>

        <el-descriptions>
        <el-descriptions-item label="信守文明经营承诺书">
          <template v-for="url in boothInfo.civilizationCommitment">
            <el-image
              :preview-src-list="boothInfo.civilizationCommitment"
              :src="url"
              style="width: 100px; height: 100px"
            >
            </el-image>
          </template>
        </el-descriptions-item>
        </el-descriptions>

        <el-descriptions>
        <el-descriptions-item label="市容环境卫生责任书">
          <template v-for="url in boothInfo.environmentalResponsibility">
            <el-image
              :preview-src-list="boothInfo.environmentalResponsibility"
              :src="url"
              style="width: 100px; height: 100px"
            >
            </el-image>
          </template>
        </el-descriptions-item>
        </el-descriptions>

        <el-descriptions>
        <el-descriptions-item label="消防安全责任书">
          <template v-for="url in boothInfo.fireSafetyResponsibility">
            <el-image
              :preview-src-list="boothInfo.fireSafetyResponsibility"
              :src="url"
              style="width: 100px; height: 100px"
            >
            </el-image>
          </template>
        </el-descriptions-item>
        </el-descriptions>

        <el-descriptions>
        <el-descriptions-item label="门前三包">
          <template v-for="url in boothInfo.guarantees">
            <el-image :preview-src-list="boothInfo.guarantees" :src="url" style="width: 100px; height: 100px">
            </el-image>
          </template>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <devicePlayer ref="devicePlayer" ></devicePlayer>
  </div>
</template>

<script>
import AMapComponent from './common/AMapComponent.vue';
import DeviceService from './service/DeviceService';
import BoothAreaList from './common/BoothAreaList.vue';
import channelMapInfobox from './dialog/channelMapInfobox';
import devicePlayer from './dialog/devicePlayer.vue';
import queryTrace from './dialog/queryTrace.vue';

const imageKey = [
  'businessCommitment',
  'civilizationCommitment',
  'environmentalResponsibility',
  'fireSafetyResponsibility',
  'guarantees',
  'healthCertificate',
  'identityCard',
  'photo',
  'publicCard',
  'registerCard',
  'residenceCertificate',
];

export default {
  name: 'Map',
  components: {
    AMapComponent,
    BoothAreaList,
    channelMapInfobox,
    devicePlayer,
    queryTrace,
  },
  data() {
    return {
      onOff: typeof window.mapParam !== 'undefined' && window.mapParam.enable,
      deviceService: new DeviceService(),
      layer: null,
      lineLayer: null,
      channel: null,
      device: null,
      infoBoxId: null,
      labelStyle: {
        width: '56px',
      },
      isLoging: false,
      longitudeStr: 'longitude',
      latitudeStr: 'latitude',
      list: [],
      baInfo: {},
      dialogVisible: false,
      boothInfo: {},
      showPoint:false,
      itemData:null,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    clickEvent: function (device, data, isCatalog) {
      this.device = device;
      if (data.channelId && !isCatalog) {
        // 点击通道
        if (data[this.longitudeStr] * data[this.latitudeStr] === 0) {
          this.$message.error('未获取到位置信息');
        } else {
          if (this.layer != null) {
            this.$refs.map.removeLayer(this.layer);
          }
          this.closeInfoBox();
          this.layer = this.$refs.map.addLayer(
            [
              {
                position: [data[this.longitudeStr], data[this.latitudeStr]],
                image: {
                  src: this.getImageByChannel(data),
                  anchor: [0.5, 1],
                },
                data: data,
              },
            ],
            this.featureClickEvent,
          );
          this.$refs.map.panTo([data[this.longitudeStr], data[this.latitudeStr]], mapParam.maxZoom);
        }
      }
    },
    contextmenuEventHandler: function (device, event, data, isCatalog) {
      this.device = device;
      if (data.channelId && !isCatalog) {
        // 点击通道
        this.$contextmenu({
          items: [
            {
              label: '播放',
              icon: 'el-icon-video-play',
              disabled: device.online === 0,
              onClick: () => {
                this.play(data);
              },
            },
            {
              label: '编辑位置',
              icon: 'el-icon-edit',
              disabled: false,
              onClick: () => {
                this.edit(data);
              },
            },
            {
              label: '轨迹查询',
              icon: 'el-icon-map-location',
              disabled: false,
              onClick: () => {
                this.getTrace(data);
              },
            },
          ],
          event, // 鼠标事件信息
          customClass: 'custom-class', // 自定义菜单 class
          zIndex: 3000, // 菜单样式 z-index
        });
      } else {
        if (typeof data.channelId === 'undefined') {
          this.deviceOrSubChannelMenu(event, data);
        } else {
          // TODO 子目录暂时不支持查询他下面所有设备, 支持支持查询直属于这个目录的设备
          this.deviceOrSubChannelMenu(event, data);
        }
      }
    },
    deviceOrSubChannelMenu: function (event, data) {
      // 点击设备
      this.$contextmenu({
        items: [
          {
            label: '定位',
            icon: 'el-icon-s-promotion',
            disabled: false,
            onClick: () => {
              if (!data.channelId) {
                this.deviceService.getAllChannel(false, false, data.deviceId, this.channelsHandler);
              }
              if (data.channelId && data.subCount > 0) {
                // 点击子目录
                this.deviceService.getAllSubChannel(false, data.deviceId, data.channelId, this.channelsHandler);
              }
            },
          },
          {
            label: '查询轨迹',
            icon: 'el-icon-map-location',
            disabled: false,
            onClick: () => {
              this.getTrace(data);
            },
          },
        ],
        event, // 鼠标事件信息
        customClass: 'custom-class', // 自定义菜单 class
        zIndex: 3000, // 菜单样式 z-index
      });
    },
    channelsHandler: function (channels) {
      if (channels.length > 0) {
        this.clean();
        this.closeInfoBox();
        let params = [];

        for (let i = 0; i < channels.length; i++) {
          let longitude = channels[i][this.longitudeStr];
          let latitude = channels[i][this.latitudeStr];
          if (longitude * latitude === 0) {
            continue;
          }
          let item = {
            position: [longitude, latitude],
            image: {
              src: this.getImageByChannel(channels[i]),
              anchor: [0.5, 1],
            },
            data: channels[i],
          };
          params.push(item);
        }

        this.layer = this.$refs.map.addLayer(params, this.featureClickEvent);
        if (params.length === 1) {
          this.$refs.map.panTo([channels[0][this.longitudeStr], channels[0][this.latitudeStr]], mapParam.maxZoom);
        } else if (params.length > 1) {
          this.$refs.map.fit(this.layer);
        } else {
          this.$message.error('未获取到位置信息');
        }
      } else {
        this.$message.error('未获取到位置信息');
      }
    },
    getImageByChannel: function (channel) {
      let src = 'static/images/gis/camera.png';
      switch (channel.ptztype) {
        case 1:
          if (channel.status === 1) {
            src = 'static/images/gis/camera1.png';
          } else {
            src = 'static/images/gis/camera1-offline.png';
          }
          break;
        case 2:
          if (channel.status === 1) {
            src = 'static/images/gis/camera2.png';
          } else {
            src = 'static/images/gis/camera2-offline.png';
          }
          break;
        case 3:
          if (channel.status === 1) {
            src = 'static/images/gis/camera3.png';
          } else {
            src = 'static/images/gis/camera3-offline.png';
          }
          break;
        default:
          if (channel.status === 1) {
            src = 'static/images/gis/camera.png';
          } else {
            src = 'static/images/gis/camera-offline.png';
          }
      }
      return src;
    },
    featureClickEvent: function (channels) {
      this.closeInfoBox();
      if (channels.length > 0) {
        this.channel = channels[0];
      }
      this.$nextTick(() => {
        let position = [this.channel[this.longitudeStr], this.channel[this.latitudeStr]];
        this.infoBoxId = this.$refs.map.openInfoBox(position, this.$refs.infobox, [0, -50]);
      });
    },
    closeInfoBox: function () {
      if (this.infoBoxId != null) {
        this.$refs.map.closeInfoBox(this.infoBoxId);
      }
    },
    play: function (channel) {
      let deviceId = channel.deviceId;
      this.isLoging = true;
      let channelId = channel.channelId;
      let that = this;
      this.$axios({
        method: 'get',
        url: '/api/play/start/' + deviceId + '/' + channelId,
      })
        .then(function (res) {
          that.isLoging = false;
          if (res.data.code === 0) {
            that.$refs.devicePlayer.openDialog('media', deviceId, channelId, {
              streamInfo: res.data.data,
              hasAudio: channel.hasAudio,
            });
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(function (e) {});
    },
    edit: function (data) {
      this.$message.warning('暂不支持');
    },
    getTrace: function (data) {
      // this.$message.warning('暂不支持');
      this.clean();
      this.$refs.queryTrace.openDialog(data, (channelPositions) => {
        if (channelPositions.length === 0) {
          this.$message.success('未查询到轨迹信息');
        } else {
          let positions = [];
          for (let i = 0; i < channelPositions.length; i++) {
            if (channelPositions[i][this.longitudeStr] * channelPositions[i][this.latitudeStr] > 0) {
              positions.push([channelPositions[i][this.longitudeStr], channelPositions[i][this.latitudeStr]]);
            }
          }
          if (positions.length === 0) {
            this.$message.success('未查询到轨迹信息');
            return;
          }
          this.lineLayer = this.$refs.map.addLineLayer(positions);
          this.$refs.map.fit(this.lineLayer);
        }
      });
    },
    clean: function () {
      if (this.lineLayer != null) {
        this.$refs.map.removeLayer(this.lineLayer);
      }
      if (this.infoBoxId != null) {
        this.$refs.map.closeInfoBox(this.infoBoxId);
      }
      if (this.layer != null) {
        this.$refs.map.removeLayer(this.layer);
      }
    },
    async getList() {
      const e = await this.$axios({
        method: 'get',
        url: '/api/biz/query/boothAreaList',
      });

      this.list = e.data.data.map((item) => {
        return {
          ...item,
          gdFenceData: JSON.parse(item.gdFenceData),
          gdPointData: JSON.parse(item.gdPointData),
        };
      });

      this.$refs.amap.initAMapWithData();
    },
    handleAreaClick(e) {
      this.$refs.amap.setZoomAndCenter(e.gdFenceData[0]);
      this.handleSelectedArea(e.baNo);
      this.showPoint = true;
    },
    async handlePointClick(areaInfo, pointInfo) {
      this.$refs.amap.setZoomAndCenter([pointInfo.lng, pointInfo.lat]);
      this.baInfo = areaInfo;

      if (!pointInfo.boothNo) return;
      this.$refs.amap.removeMarkers(1);
      this.$refs.amap.initMarker(areaInfo.baNo);

      const e = await this.$axios({
        method: 'get',
        url: `/api/biz/query/boothInfo/${pointInfo.boothNo}`,
      });

      this.boothInfo = Object.keys(e.data.data).reduce((acc, cur) => {
        const value = e.data.data[cur];
        if (imageKey.includes(cur)) {
          acc[cur] = JSON.parse(value);
        } else {
          acc[cur] = value;
        }
        return acc;
      }, {});

      this.dialogVisible = true;
      if(this.boothInfo && this.boothInfo.device != null){
        this.getDeviceChannelList(this.boothInfo.device.deviceId);
      }
    },
    backToArea(){
      this.$refs.amap.backToArea();
      this.showPoint = false;
    },
    handleSelectedArea(baNo) {
      this.baInfo = this.list.find((item) => item.baNo === baNo);
      this.$refs.amap.removeMarkers(1);
      this.$refs.amap.initMarker(baNo);
      this.showPoint = true;
    },
    /*20230409新增探头播放*/
    getDeviceChannelList: function (deviceId) {
      let that = this;
      if (typeof deviceId == "undefined") return;
      this.$axios({
        method: 'get',
        url: `/api/device/query/devices/${deviceId}/channels`,
        params: {
          page: 1,
          count: 10,
          query: "",
          online: "",
          channelType: ""
        }
      }).then(function (res) {
        if (res.data.code === 0) {
          let list = res.data.data.list;
          that.itemData = list.find(item=>item.deviceId == deviceId);
          }
      }).catch(function (error) {
        console.log(error);
      });
    },
    initData: function () {
      this.getDeviceChannelList();
    },
    //通知设备上传媒体流
    sendDevicePush: function (boothInfo) {
      let that = this;
      let deviceId = boothInfo.device.deviceId;
      let itemData = that.itemData;
      console.log(itemData);
      if(!itemData || itemData == null) return;
      this.isLoging = true;
      let channelId = itemData.channelId;
      console.log("通知设备推流1：" + deviceId + " : " + channelId);
      this.$axios({
        method: 'get',
        url: '/api/play/start/' + deviceId + '/' + channelId
      }).then(function (res) {
        console.log(res)
        that.isLoging = false;
        if (res.data.code === 0) {

          setTimeout(() => {

            let snapId = deviceId + "_" + channelId;
            that.loadSnap[deviceId + channelId] = 0;
            that.getSnapErrorEvent(snapId)
          }, 5000)
          itemData.streamId = res.data.data.stream;
          that.$refs.devicePlayer.openDialog("medias", deviceId, channelId, {
            streamInfo: res.data.data,
            hasAudio: itemData.hasAudio
          });
          setTimeout(() => {
            that.initData();
          }, 1000)

        }else{
          that.$message.error(res.data.msg);
        }
      }).catch(function (e) {
        console.error(e)
        that.isLoging = false;
        // that.$message.error("请求超时");
      });
    },
    getSnapErrorEvent: function (deviceId, channelId) {

      if (typeof (this.loadSnap[deviceId + channelId]) != "undefined") {
        console.log("下载截图" + this.loadSnap[deviceId + channelId])
        if (this.loadSnap[deviceId + channelId] > 5) {
          delete this.loadSnap[deviceId + channelId];
          return;
        }
        setTimeout(() => {
          let url = (process.env.NODE_ENV === 'development'? "debug": "") + '/api/device/query/snap/' + deviceId + '/' + channelId
          this.loadSnap[deviceId + channelId]++
          document.getElementById(deviceId + channelId).setAttribute("src", url + '?' + new Date().getTime())
        }, 1000)

      }
    },
  },
};
</script>

<style>
.infobox-content {
  padding: 8px;
  background-color: white;
}

.map.style1 {
  height: calc(100vh - 217px);
}
.map.style2 {
  height: 100vh;
}
.video-layer{
  position: fixed;
  width: 100vw;
  height: 100vh;
  left:0;
  top:0;
  z-index: 9999;
}
.play-box{
  width: 100%;
  height: 100%;
  border: 2px solid red;
}
</style>



// WEBPACK FOOTER //
// src/components/map.vue